/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  // Button,
  Snackbar,
  TextField,
} from "@common-ui/ui";
// import { MainDialog } from "./MainDialog";
// import { Add } from "@mui/icons-material";
import _ from "lodash";
import {
  // getAssets,
  updateWorkItem,
  getAssetsRelated,
} from "../../services";
// import { getCustomerAssets } from "../../services";

const EquipmentList = ({
  workEvent,
  orgID,
  workItem,
  mode,
  report,
  rowProp,
}) => {
  const [mainDialog, setMainDialog] = useState({ isOpen: false });
  // const [updatedLeft, setUpdatedLeft] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [toast, setToast] = useState([]);

  const [assets, setAssets] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [allAsset, setAllAsset] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const handleClose = async () => {
    setMainDialog({ ...mainDialog, isOpen: false });
  };
  // const handleOpen = () => {
  //   setMainDialog({ ...mainDialog, isOpen: true });
  // };

  useEffect(async () => {
    await init();
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function init() {
    try {
      const { assets } = await getAssetsRelated();
      const equipmentIds = workItem.equipment;
      // const equipmentIds = [
      //   "a2e42ef4-93dc-40ea-abcc-5c6a2d66c335",
      //   "47bea92b-9cdf-4fa1-9d16-339907e35588",
      // ];
      const indexLookUp = _.keyBy(equipmentIds, (id) => {
        return id;
      });
      const filterNewAssets = _.filter(assets, (asset) => {
        return indexLookUp[asset.system_id] === undefined;
      });

      const filterEquipment = _.filter(assets, (asset) => {
        return indexLookUp[asset.system_id] !== undefined;
      });

      // console.log(
      //   "filterEquipment",
      //   filterEquipment,
      //   "filterNewAssets",
      //   filterNewAssets
      // );
      setAssets(filterNewAssets);
      setEquipments(filterEquipment);

      setAllAsset(assets);
    } catch (error) {
      console.log("error", error);
    }
    // setIsLoading(false);
  }

  const handleSubmit = async (equipments) => {
    setIsLoading(true);
    const equipmentIds = equipments.map((item) => item.system_id);
    const attributes = {
      equipment: equipmentIds,
    };
    await updateWorkItem(attributes, workItem.work_event, workItem.id, orgID);
    try {
      setToast([
        ...toast,
        {
          message: "Equipment has been saved.",
          open: true,
          severity: "success",
        },
      ]);
      setIsLoading(false);
      handleClose();
    } catch (error) {
      setToast([
        ...toast,
        {
          message: error?.message,
          open: true,
          severity: "error",
        },
      ]);
      setIsLoading(false);
      handleClose();
    }
  };

  return isLoading ? (
    "Loading..."
  ) : (
    <Box>
      {/* {!report ? (
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={() => handleOpen()}
          disabled={report}
        >
          Add Equipment
        </Button>
      ) : (
        ""
      )} */}
      <Autocomplete
        multiple
        options={assets}
        size="small"
        sx={{ mt: 0 }}
        disabled={rowProp?.status === "COMPLETED"}
        // value={formik.values.performing_user}
        defaultValue={equipments}
        fullWidth
        onChange={(_e, value) => {
          setEquipments(value);
          handleSubmit(value);
        }}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ mt: 0 }}
            variant="outlined"
            placeholder="Select Equipment"
            inputProps={{
              ...params.inputProps,
            }}
            name="performingUser"
            id="performingUser"
            // error={Boolean(
            //   formik.touched.performing_user && formik.errors.performing_user
            // )}
            // helperText={
            //   formik.touched.performing_user && formik.errors.performing_user
            // }
            // onBlur={formik.handleBlur}
          />
        )}
      />
      {/* <MainDialog
        workEventID={workItem?.id}
        open={mainDialog.isOpen}
        handleClose={handleClose}
        workItems={equipments}
        setWorkItems={setEquipments}
        data={assets}
        setAssets={setAssets}
        handleSubmit={handleSubmit}
        orgID={orgID}
        updatedLeft={updatedLeft}
        setUpdatedLeft={setUpdatedLeft}
        isLoading={isLoading}
        allAsset={allAsset}
      /> */}
      {toast.map((item, id) => {
        return (
          <Snackbar
            key={id}
            open={item.open}
            autoHideDuration={6000}
            onClose={() => {
              setToast(toast.filter((v, i) => i !== id));
            }}
          >
            <Alert
              onClose={() => {
                setToast(toast.filter((v, i) => i !== id));
              }}
              severity={item.severity}
              sx={{ width: "100%" }}
              variant="filled"
            >
              {item.message}
            </Alert>
          </Snackbar>
        );
      })}
    </Box>
  );
};

export { EquipmentList };
